import * as Yup from "yup";

export type DefaultFieldValues = typeof defaultFieldValues;

export type defaultFieldValuesType = {
  debts: {
    debtType: string;
    interestRate: string;
    amount: string;
    monthlyPayment: string;
  }[];
};

export type debtCardType = {
  debtType: string;
  interestRate: string;
  amount: string;
  monthlyPayment: string;
};

export const defaultFieldValues = {
  debts: [
    {
      debtType: "",
      interestRate: "",
      amount: "",
      monthlyPayment: "",
    },
  ],
};

export const validationSchema = Yup.object({
  debts: Yup.array().of(
    Yup.object({
      debtType: Yup.string().required("Please select a debt type"),
      amount: Yup.string()
        .matches(/^(?!0)/, {
          message: "Please enter your total owed (min $1)",
        })
        .max(7, "Please enter your total owed (max $999,999)")
        .required("Please enter your total owed"),
      interestRate: Yup.string().required("Please enter your APR"),
      monthlyPayment: Yup.string()
        .matches(/^(?!0)/, {
          message: "Please enter your monthly payment (min $1)",
        })
        .max(5, "Please enter your monthly payment (max $9,999)")
        .required("Please enter your monthly payment"),
    }),
  ),
});
